// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_tax_deduction_type.ml",
      74,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "TaxDeductionType"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    });

const Tax = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_tax_deduction_type.ml",
      113,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxDeductionType"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_tax_deduction_type.ml",
      150,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxDeductionType"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_tax_deduction_type.ml",
      185,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxDeductionType"
        ]]
    });

const TaxDeductionType = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_tax_deduction_type.ml",
      216,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.tax.control.v1.TaxDeductionType";
}

function to_int(param) {
  switch (param) {
    case /* TAX_DEDUCTION_TYPE_UNSPECIFIED */0 :
        return 0;
    case /* TAX_DEDUCTION_TYPE_1_MZP */1 :
        return 10;
    case /* TAX_DEDUCTION_TYPE_882_MRP */2 :
        return 20;
    case /* TAX_DEDUCTION_TYPE_14_MRP */3 :
        return 30;
    
  }
}

function from_int_exn(n) {
  if (n >= 11) {
    if (n !== 20) {
      if (n !== 30) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* TAX_DEDUCTION_TYPE_14_MRP */3;
      }
    } else {
      return /* TAX_DEDUCTION_TYPE_882_MRP */2;
    }
  } else if (n !== 0) {
    if (n >= 10) {
      return /* TAX_DEDUCTION_TYPE_1_MZP */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* TAX_DEDUCTION_TYPE_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* TAX_DEDUCTION_TYPE_UNSPECIFIED */0 :
        return "TAX_DEDUCTION_TYPE_UNSPECIFIED";
    case /* TAX_DEDUCTION_TYPE_1_MZP */1 :
        return "TAX_DEDUCTION_TYPE_1_MZP";
    case /* TAX_DEDUCTION_TYPE_882_MRP */2 :
        return "TAX_DEDUCTION_TYPE_882_MRP";
    case /* TAX_DEDUCTION_TYPE_14_MRP */3 :
        return "TAX_DEDUCTION_TYPE_14_MRP";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "TAX_DEDUCTION_TYPE_14_MRP" :
        return /* TAX_DEDUCTION_TYPE_14_MRP */3;
    case "TAX_DEDUCTION_TYPE_1_MZP" :
        return /* TAX_DEDUCTION_TYPE_1_MZP */1;
    case "TAX_DEDUCTION_TYPE_882_MRP" :
        return /* TAX_DEDUCTION_TYPE_882_MRP */2;
    case "TAX_DEDUCTION_TYPE_UNSPECIFIED" :
        return /* TAX_DEDUCTION_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, TaxDeductionType, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxDeductionType"
        ]]
    }, V1, {
      TaxDeductionType: TaxDeductionType
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxDeductionType"
              ]]
          },
          "V1"
        ]]
    }, Control, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxDeductionType"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    }, Tax, {
      Control: Control
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "TaxDeductionType"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    }, Buhta, {
      Tax: Tax
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
